export default class {

  constructor(coachGateway, dataService) {
    this.coachGateway = coachGateway;
    this.dataService = dataService;
    this.initialDataIsLoaded = false;
    this.callbackStack = [];
  }

  invalidateSession() {
    this.user = null;
    this.data = null;
    sessionStorage.user = null;
    this.initialDataIsLoaded = null;
    this.dataService.clear();
  }

  get secret_key() {
    return this.dataService.secretKey;
  }

  get data() {
    return this.dataService.retrieve('data');
  }

  set data(value) {
    this.dataService.store('data', value);
  }

  executeCallbackStack() {
    this.callbackStack.forEach(callback => callback());
  }

  initializeStoredSession(onSuccess) {
    if (sessionStorage.user) {
      this.initialDataIsLoading = true;
      this.retrieveSessionFromStorage();
      this.loadInitialData().then(() => {
        this.initialDataIsLoaded = true;
        this.initialDataIsLoading = false;
        this.executeCallbackStack();
        onSuccess();
      });
    }
  }

  executeWithInitializedSession(onSuccess) {
    if (this.initialDataIsLoaded) {
      // console.log('dataisloaded');
      onSuccess();
      this.executeCallbackStack();
    } else if (this.initialDataIsLoading) {
      // console.log('dataisloading');
      this.callbackStack.push(onSuccess);
    } else {
      // console.log('initializing session');
      this.initializeStoredSession(onSuccess);
    }
  }

  saveToStorage() {
    sessionStorage.user = JSON.stringify(this.user);
  }

  retrieveSessionFromStorage() {
    this.user = JSON.parse(sessionStorage.user);
  }

  loadInitialData() {
    return this.coachGateway.getDataForCoachInterface(this.secret_key)
      .then(data => this.data = data);
  }

  // Changes from rethinking below:

  ensureInitializedSession() {
    return new Promise(resolve => {
      this.executeWithInitializedSession(() => {
        resolve();
      });
    });
  }

  withWorkspaces(block) {
    this.executeWithInitializedSession(() => {
      return block(this.data.workspaces);
    })
  }
}